import React from 'react';

const BackgroundAnimation = () => {
  return (
    <>
      <div className="background-3d" />
      <div 
        className="morph-bg" 
        style={{ 
          top: '10%', 
          left: '-10%',
          filter: 'blur(80px)'
        }} 
      />
      <div 
        className="morph-bg" 
        style={{ 
          bottom: '5%', 
          right: '-5%',
          filter: 'blur(100px)',
          animationDelay: '5s'
        }} 
      />
    </>
  );
};

export default BackgroundAnimation;
